import React, { useState } from "react";

import { ROUTES } from "./Route";
import Login from "../Account/Login";
import UserManagementScreen from "./UserManagementScreen";
import CretorDetail from "./CretorDetail";

export default function UserManagement() {
  const [filter, setFilter] = useState("CREATOR");
  const [page, setPage] = useState(ROUTES.USER_MANAGEMENT);
  const [editedData, setEditedData] = useState("");

  switch (page) {
    case ROUTES.USER_MANAGEMENT:
      return (
        <UserManagementScreen
          setPage={setPage}
          filter={filter}
          setFilter={setFilter}
          editedData={editedData}
          setEditedData={setEditedData}
        />
      );
    default:
      return (
        <CretorDetail
          setPage={setPage}
          editedData={editedData}
          setEditedData={setEditedData}
        />
      );
  }
}
